import generalSection from "../_section/section.class";
import {adminCreditStatementUpload, userCreditStatementUpload} from "./upload";
import ApplicationForm from "./ApplicationForm";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";
import dayjs from "dayjs";
export class userCreditStatementSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userCreditStatementUpload);
        // Add missing date error
    }
}

export class adminCreditStatementSection extends userCreditStatementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminCreditStatementUpload);
        this.sortByDateProp('documentDate')
        this.ApplicationForm = ApplicationForm
        this.DataForm = DataForm;
        this.setUploadsRanges(
            (() => {
                const activeUploads = [...this.uploads].reverse().filter(it => it.isActive && it.isVerifiable);
                return activeUploads.flatMap((upload, uploadIndex) => {
                    if (!upload?.dateData?.range?.ok) {

                        return [];
                    }
                    const nextUploadWithOpening = activeUploads.find((it, i) => i > uploadIndex && it?.dateData?.range?.from?.date);
                    const openingDateOfNextUpload = nextUploadWithOpening ? nextUploadWithOpening?.dateData?.range?.from?.date : null;
                    // if there are start or end props available, use them, as they are the dates on the alignment endDate/startDate
                    let thisEnd = upload?.dateData?.range?.to
                    let thisStart = upload?.dateData?.range?.from


                    // this now updates the current upload end date, if the next upload opening date is before it
                    if (thisEnd?.date && openingDateOfNextUpload && openingDateOfNextUpload.isBefore(thisEnd.date)) {
                        let neededEndDate = openingDateOfNextUpload

                        thisEnd = {
                            date: neededEndDate,
                            balance: null // to detect if null to make error later!
                        }

                    }
                    if (this.personalTitle === "Erin's Bank of America credit card"){
                        console.log({thisEnd,thisStart})
                    }

                    return [
                        {
                            start: thisStart,
                            end: thisEnd,
                            uploadId: upload.id,
                        }
                    ]
                })
            })()
        )
        this.setProblems( this.getProblems() );
    }
    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();

        if (!problems.length) {
            const iban = this.data?.accountNumber
            if (!iban) {
                problems.push(
                    new problem({
                        type: "BUNDLE",
                        title: 'Account No not set',
                        message: 'Account No missing from application',
                    })
            )
            }
            if (!this?.progress?.requiredRanges){
                problems.push(...this.problemsList.summaryRangeTooShort(6, 'months'))
            }
            if (this?.progress?.requiredRanges){
                const start = this.progress.requiredRanges[0]?.start ? dayjs(this.progress.requiredRanges[0].start) : null;
                const end = this.progress.requiredRanges[0]?.end ? dayjs(this.progress.requiredRanges[0].end) : null;
                const expandedRange = this.calcExpandedRange(start, end);
                problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            }
            else if (this.statementAlignmentDate) {
                const expandedRange = this.calcExpandedRange(this.statementAlignmentDate.add(1,'day').subtract(6, 'months'), this.statementAlignmentDate);
                problems.push(...this.problemsList.missingInExpandedRange(expandedRange))
            }
        }
        return problems
    }
    getSectionSummary = () => {
        const tags = []
        const highestCreditUtilisation = this.activeUploads.reduce((acc, current) => {
            if ((current.values?.outstanding||0) > acc){
                acc = current.values?.outstanding||0
            }
            return acc
        }, 0)
        const lastOutstanding = [...this.activeUploads].sort((a,b)=> b.values?.documentDate?.unix() - a.values?.documentDate?.unix())[0]?.outstanding
        const lastestLimit = [...this.activeUploads].sort((a,b)=> b.values?.documentDate?.unix() - a.values?.documentDate?.unix())[0]?.creditLimit
        if (lastOutstanding){
            tags.push({
                name: 'Outstanding',
                value: lastOutstanding,
            })
        }
        if (lastestLimit){
            tags.push({
                name: 'Credit Limit',
                value: lastestLimit,
            })
        }
        if (highestCreditUtilisation){
            tags.push({
                name: 'Highest Utilisation',
                value: highestCreditUtilisation,
            })
        }
        return [{
            name: `${this.personalTitle} ${this.data.accountNumber}`,
            tags: tags,
        }]
    }
}